<template>
  <div>
    <BodyLoader :loading="firstLoad"></BodyLoader>
    <div class="dvModals">
      <div id="modal-send-print" class="modal">
        <div class="dvModalHeader">
          <div class="dvModalHeader-title">
            Send Email
          </div>
          <a class="modal-close waves-effect waves-dark btn-Close flexCenterAll" href="javascript:void(0)"><span class="icon-action_cancel"></span></a>
        </div><!--dvModalHeader-->

        <div class="dvModalContent">
          <form>
            <div class="row">
              <div class="col s12 l12 dvModalContent-field">
                <label class="defaultModal-label">Email Address</label>
                <input v-model="printSendTo" class="browser-default defaultModal-input" placeholder="e.g. juan.delacruz@ayalaland-intl.com" type="text" />
                <div class="defaultModal-helper-text">
                  * Required
                </div>
                <div class="defaultModal-helper-text">
                  Multiple email addresses should be , separated. For ex: j@email.com, m@email.com
                </div>
              </div>
            </div>
          </form>
        </div><!--dvModalContent-->
        <div class="dvModalFooter">
          <a
            v-if="!sendingPrint"
            @click="sendlPrint()"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            <span class="icon-action_check"></span>Send
          </a>

          <a
            v-if="sendingPrint"
            href="javascript:void(0)"
            :class="{ disabled: true }"
            class="waves-effect waves-light btn btn-Tools btnSubmit flexCenterAll">
            Sending...
          </a>

          <a
            :disabled="sendingPrint"
            @click="closeModal('modal-send-print')"
            href="javascript:void(0)" class="waves-effect waves-light btn btn-Tools btnCancel flexCenterAll"><span class="icon-action_cancel"></span>Cancel</a>
        </div>
      </div><!-- modal-->
    </div>

    <div class="dvQuickGlance">
      <div class="dvQuickGlance-client">
          <div class="dvQuickGlance-client-profile">
            <div class="dvQuickGlance-client-profile-pic circle flexCenterAll" :class="$store.getters.classReferralBg(client)">
                <span class="icon-fs_user"></span>
            </div>
            <div class="dvQuickGlance-client-profile-name">
              {{ $store.getters.formatFullName(client.first_name, client.last_name) }}
            </div>
          </div>

          <div class="dvQuickGlance-client-content">
            <div class="dvQuickGlance-client-owner" v-if="$getConstRole('ROLE_MANAGER') == $store.getters.getCurrentUserRole && client.referred_by != $store.getters.getCurrentUserDetails.id">
              <div class="dvQuickGlance-client-owner-item seller">
                <span class="icon-content_tag"></span>
                <router-link
                  class="waves-effect waves-light dvCardClient-content-items-link"
                  :to="{ name:'team_member', params: { id: client.referred_by, status: 'valid' } }">
                  {{ $store.getters.formatFullName(client.referred_by_first_name, client.referred_by_last_name) }}
                </router-link>
              </div>
              <div class="dvQuickGlance-client-owner-item team">
                <span class="icon-fs_world"></span>
                <router-link
                  class="waves-effect waves-light dvCardClient-content-items-link"
                  :to="{ name:'teams' }">
                  {{ team.channel }} - {{ team.team }}
                </router-link>
              </div>
              <div class="dvQuickGlance-client-owner-item team-manager">
                <span class="icon-action_star"></span>
                <router-link
                  class="waves-effect waves-light dvCardClient-content-items-link"
                  :to="{ name:'team_member', params: { id: team.manager_id, status: 'valid' } }">
                  {{ team.manager }}
                </router-link>
              </div>
            </div>
            <div class="dvQuickGlance-client-tools">
              <a
                v-show="hasContact(client)"
                class="waves-effect waves-light btn btn-Tools forClient flexCenterAll"
                :href="'tel:'+(client.mobile_no.length > 0 ? client.mobile_no : '')"><span class="icon-content_telephone"></span>Call Client</a>
              <a class="waves-effect waves-light btn btn-Tools forClient flexCenterAll"
                :href="'mailto:'+client.email"><span class="icon-content_email"></span>Email Client</a>
                <!-- v-show="$getConstRole('ROLE_SELLER') == $store.getters.getCurrentUserRole" -->
              <a
                v-show="client.archive != 1"
                :name="'client-view-menu'"
                :ref="'tippy__client_view_menu'"
                class="waves-effect waves-dark btn-Menu-more flexCenterAll" href="javascript:void(0)"><span class="icon-nav_more_horz"></span></a>
            </div>
          </div>
      </div><!--  dvQuickGlance-client -->
    </div><!--  dvQuickGlance -->

    <tippy
     v-bind:to="'client-view-menu'"
     placement="bottom-end"
     offset="[10, 0]"
     interactive
     arrow
     trigger="click">
     <div class="morePopMenuBox-content ">
       <router-link
         v-show="client.archive != 1"
         class="morePopMenuBox-content-item"
         :to="{ name:'teams_client_update', params: { id: client.slug } }">
         <span class="icon-action_edit"></span>Edit
       </router-link>

       <a
        v-if="client.expiring == 1 && client.extended_allowed == 1"
        @click="confirm({
          id: client.id,
          type: 'extend-referral',
          available_extended: client.available_extended
        })"
        href="javascript:void(0)" class="morePopMenuBox-content-item">
         <span class="icon-action_refresh"></span>Extend
       </a>

       <a
        v-if="$store.getters.forArchive(client)"
        @click="confirm({
          id: client.id,
          type: 'archive',
          client: $store.getters.formatFullName(client.first_name, client.last_name)
        })"
        href="javascript:void(0)" class="morePopMenuBox-content-item">
         <span class="icon-action_archive"></span>Archive
       </a>

       <!-- <a href="#" class="morePopMenuBox-content-item">
         <span class="icon-action_check"></span>Resolve
       </a> -->
       <!-- <a href="#" class="morePopMenuBox-content-item">
         <span class="icon-action_refresh"></span>Extend
       </a>
       <a href="#" class="morePopMenuBox-content-item">
         <span class="icon-action_archive"></span>Archive
       </a> -->
     </div>
   </tippy>




    <div class="row dvContent">

      <div class="col s12 dvContentMain">
        <div class="dvSectionTitleOpts hide">
          <div class="dvSectionTitleOpts-title">
            <span class="icon-fs_user"></span>Add New Client
          </div> <!-- dvSectionTitleOpts-title -->
        </div> <!-- dvSectionTitleOpts -->

        <div class="dvClientForm">

          <div class="dvClientFormBox">
            <div class="dvClientFormBox-header valign-wrapper">
              <div class="dvClientFormBox-header-title">
                Client Information
              </div>
              <router-link
                v-if="client.archive != 1"
                class="dvClientFormBox-header-btn btn waves-effect waves-light flexCenterAll"
                :to="{ name:'teams_client_update', params: { id: client.slug }, query: { target: 'client-info-container' } }">
                edit <span class="icon-action_edit"></span>
              </router-link>
            </div>
            <div class="dvClientFormBox-content">
              <div class="row">
                <form class="col s12">
                  <div class="row">
                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.first_name"
                          label="First Name"
                          required
                          disabled
                          hint="* Required"
                          prepend-icon="icon-fs_user">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.last_name"
                          label="Last Name"
                          required
                          disabled
                          hint="* Required"
                          prepend-icon="icon-fs_user">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.email"
                          label="E-mail Address"
                          required
                          disabled
                          hint="* Required"
                          placeholder="(e.g. juan.delacruz@email.com)"
                          prepend-icon="icon-content_email">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.mobile_no"
                          label="Mobile Number"
                          type="tel"
                          disabled
                          prepend-icon="icon-content_mobile">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.country_name"
                          label="Country"
                          disabled
                          prepend-icon="icon-fs_world">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.state_province"
                          label="State / Province"
                          disabled
                          prepend-icon="icon-content_location">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.city"
                          label="City"
                          disabled
                          prepend-icon="icon-content_location">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                  </div><!-- row -->
                </form><!-- form -->
              </div><!-- row -->
            </div><!-- dvClientFormBox-content -->
          </div> <!-- dvClientFormBox -->


          <ProjectInfoView
            :projectIdx="index"
            :client="client"
            :projectsCnt="projectInquiries.length"
            :projectInquiryDetails="projectInquiry"
            @editProject="editProject"
            v-for="(projectInquiry, index) in projectInquiries" :key="index">
          </ProjectInfoView>


          <div id="personal-info-container" class="dvClientFormBox" v-if="showPersonalInfo" >
            <div class="dvClientFormBox-header valign-wrapper">
              <div class="dvClientFormBox-header-title">
                Personal Information
              </div>
              <router-link
                v-if="client.archive != 1"
                class="dvClientFormBox-header-btn btn waves-effect waves-light flexCenterAll"
                :to="{ name:'teams_client_update', params: { id: client.slug }, query: { target: 'personal-info-container' } }">
                edit <span class="icon-action_edit"></span>
              </router-link>

            </div>
            <div class="dvClientFormBox-content">
              <div class="row">
                <form class="col s12">
                  <div class="row">

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.company_name"
                          label="Company Name"
                          disabled
                          prepend-icon="icon-content_office">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.occupation"
                          label="Occupation"
                          disabled
                          prepend-icon="icon-content_work">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.home_ownership"
                          label="Home Ownership"
                          disabled
                          prepend-icon="icon-nav_chevron_right">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="client.monthly_income"
                          label="Monthly Household Income"
                          disabled
                          prepend-icon="icon-nav_chevron_right">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                  </div><!-- row -->
                </form><!-- form -->
              </div><!-- row -->
            </div><!-- dvClientFormBox-content -->
          </div> <!-- dvClientFormBox -->




          <div id="home-address-container" class="dvClientFormBox" v-if="showHomeAddress" >
            <div class="dvClientFormBox-header valign-wrapper">
              <div class="dvClientFormBox-header-title">
                Home Address
              </div>
              <router-link
                v-if="client.archive != 1"
                class="dvClientFormBox-header-btn btn waves-effect waves-light flexCenterAll"
                :to="{ name:'teams_client_update', params: { id: client.slug }, query: { target: 'home-address-container' } }">
                edit <span class="icon-action_edit"></span>
              </router-link>

            </div>
            <div class="dvClientFormBox-content">
              <div class="row">
                <form class="col s12">
                  <div class="row">

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="homeAddress.address1"
                          label="Address 1"
                          disabled
                          prepend-icon="icon-content_home">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->


                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="homeAddress.city"
                          label="City"
                          disabled
                          prepend-icon="icon-content_location">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                    <div class="col l4 m12 s12">
                      <div class="dvClientFormBox-content-item">
                        <v-text-field
                          v-model="homeAddress.country_name"
                          label="Country"
                          disabled
                          prepend-icon="icon-fs_world">
                        </v-text-field>
                      </div><!-- dvClientFormBox-content-item -->
                    </div><!-- col -->

                  </div><!-- row -->
                </form><!-- form -->
              </div><!-- row -->
            </div><!-- dvClientFormBox-content -->
          </div> <!-- dvClientFormBox -->

          <DataPrivacyConsent :dataPrivacy="dataPrivacy"></DataPrivacyConsent>

          <div class="dvClientFormBox">
            <div class="dvClientFormBox-header valign-wrapper">
              <div class="dvClientFormBox-header-title">
                Activity Log
              </div>
            </div>
            <!-- historyView: {
              groupCode: '',
              hasHeader: false
            } -->

            <div class="dvClientActivity">
              <div
                v-for="(history, index) in client.histories" :key="index"
                class="row dvClientActivity-item">

                <div class="col s4 m3">
                  <div class="dvClientActivity-item-date"><span class="icon-content_activity"></span>{{ history.created_at | moment("MMMM D, YYYY") }}</div>
                </div>
                <div class="col s8 m9">
                  <div class="dvClientActivity-item-log">
                      <div v-html="history.details"></div>
                      <div>{{ history.created_at | moment("MM/DD/YY, hh:mm A") }}</div>
                  </div>
                </div>

              </div><!-- dvClientActivity-item -->

            </div><!-- dvClientActivity -->
          </div> <!-- dvClientFormBox -->

          <div class="row dvClientFormAdd hide">
            <div class="col s12 m6 l3">
              <a href="#" class="waves-effect waves-light btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_add_circle"></span>Project Inquiry</a>
            </div>
            <div class="col s12 m6 l3">
              <a href="#" class="waves-effect waves-light btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_add_circle"></span>Personal Information</a>
            </div>
            <div class="col s12 m6 l3">
              <a href="#" class="waves-effect waves-light btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_add_circle"></span>Home Address</a>
            </div>
            <div class="col s12 m6 l3">
              <a href="#" class="waves-effect waves-light btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_add_circle"></span>Office Address</a>
            </div>
          </div> <!-- dvClientFormAdd -->

        </div> <!-- dvClientForm -->

      </div> <!-- dvContentMain -->

      <div class="col s12 dvContentTools formSubmit">
        <div class="dvContentTools-fx"></div>
        <div class="dvContentTools-content">
          <!-- <a href="#" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll"><span class="icon-nav_chevron_left"></span>Previous</a>
          <a href="#" class="waves-effect waves-light btn btn-Tools isPagination flexCenterAll">Next<span class="icon-nav_chevron_right"></span></a> -->
        </div> <!-- dvContentTools-formSubmit -->

        <div class="dvContentTools-page">
          <a @click="emailPrint('modal-send-print')" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-content_email"></span><div class="hide-on-small-only">Email</div></a>
          <a @click="printJS()" href="javascript:void(0)" class="waves-effect waves-dark btn btn-Tools isSecondary flexCenterAll"><span class="icon-action_print"></span><div class="hide-on-small-only">Print</div></a>
          <ToTop></ToTop>
        </div>

      </div>

    </div> <!-- dvContent -->

    <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>
    <ConfirmationDialog
      :dialog="dialog"
      @doConfirm="doConfirm">
    </ConfirmationDialog>

  </div>
</template>

<script>
  import ProjectInfoView from './ProjectInfoView.vue'
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import ConfirmationDialog from '@/components/confirmation_view/ConfirmationDialog.vue'
  import BodyLoader from '@/components/BodyLoader.vue'
  import printJS from 'print-js'
  import M from 'materialize-css'
  import ToTop from '@/components/totop/ToTop.vue'
  import DataPrivacyConsent from '@/components/DataPrivacyConsent.vue'


  export default {
    name: 'referrals-main',
    data: () => ({
      dataPrivacy: {
        isAgree: true,
        isAgreeDisabled: true
      },
      printSendTo: '',
      sendingPrint: false,
      domain: '',
      loadedCnt: 0,
      firstLoad: true,
      dialog: {
        show: false,
        title: '',
        body: '',
        action: '',
        id: ''
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      historyView: {
        groupCode: '',
        hasHeader: false
      },
      id: '',
      client: {
        first_name: ' ',
        last_name: ' ',
        email: ' .',
        mobile_no: ' ',
        country: ' ',
        state_province: ' ',
        city: ' ',
        company_name: ' ',
        occupation: ' ',
        home_ownership: ' ',
        monthly_income: ' '
      },
      projectInquiryDetails: {
        project_interested_in: ' ',
        project_location: ' ',
        property: ' ',
        locations: ' ',

        project_type: ' '

      },
      projectInquiries: [
        {
          company_name: ' ',
          occupation: ' ',
          home_ownership: ' ',
          monthly_income: ' '
        }
      ],
      personalInfo: {
        company_name: ' ',
        occupation: ' ',
        home_ownership: ' ',
        monthly_income: ' '
      },
      homeAddress: {
        address1: ' ',
        city: ' ',
        state_province: ' ',
        country: ' ',
      },
      referralSummary: {
        pending: '',
        valid: '',
        expiring: '',
        archive: ''
      },
      projectData: {
        projects: [],
        projectLocations: []
      },
      showPersonalInfo: false,
      showHomeAddress: false,
      showOfficeAddress: false,
      team: {}
    }),
    watch: {
      loadedCnt: function() {
        if(this.loadedCnt == 2){
          this.firstLoad = false
        }
      }
    },
    computed: {

    },
    methods: {
      printJS (){
        printJS(this.domain+'/api/referrals/'+ this.id+'?request_type=print');
      },
      closeModal (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.close();

        this.printSendTo = ''
      },
      emailPrint (str){
        const elem = document.getElementById(str);
        const instance = M.Modal.init(elem, {dismissible: false});
        instance.open();
      },
      sendlPrint (){
        if(this.printSendTo == ''){
          this.showMessage('The email field is required.', 'sb-failed')
          return false
        }

        if(this.sendingPrint){
          return false
        }

        let self = this
        self.sendingPrint = true

        let url = '/api/referrals/'+ this.id+'?request_type=mail&send_to='+this.printSendTo
        this.$http.plain.get(url)
          .then(response => {
            if(response.data == 'sent'){
              this.showMessage('Email has been sent', 'sb-success')
            }
            this.printSendTo = ''
            this.closeModal('modal-send-print')
          })
          .catch(error => {
            if (error.response.status === 500) {
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }else{
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }
          })
          .then(function () {
            self.sendingPrint = false
          })
      },
      hasContact: function(client){
        return this.displayContactNos(client) == '' ? false : true
      },
      displayContactNos: function(client) {
        let mobTels = [];

        if(client.mobile_no.length > 0){
          mobTels.push(client.mobile_no)
        }

        return mobTels.join(', ')
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      confirm (action){
        document.querySelectorAll('.tippy-popper').forEach(popper => {
          popper._tippy.hide()
        })

        if(action.type == 'archive'){
          this.dialog = {
            show: true,
            title: 'Are you sure you want to archive '+action.client+'?',
            body: 'You can\'t undo this action.',
            icon: 'icon-action_archive',
            positionBtn: 'Archive',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }else if(action.type== 'extend-referral'){
          this.dialog = {
            show: true,
            title: 'Do you want to extend referral?',
            body: 'You have '+action.available_extended+' extension/s left',
            icon: 'icon-action_refresh',
            positionBtn: 'Extend',
            negativeBtn: 'Cancel',
            actionType: action.type,
            id: action.id
          }
        }

      },
      doConfirm (){
        this.dialog.show = false

        if(this.dialog.actionType == 'archive'){
          this.processArchive(this.dialog.id)
        }else if(this.dialog.actionType == 'extend-referral'){
          this.extendReferral(this.dialog.id)
        }else if(this.dialog.actionType == 'archives'){
          this.archiveSelected()
        }
      },
      processArchives (ids) {
        if(this.archiving){
          return false;
        }
        this.archiving = true
        let self = this

        this.$http.secured.post('api/referrals/archive/'+ ids)
          .then(response => {
            this.getReferral()
            this.getLatestReferralsSummary()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            this.showMessage(error, 'sb-failed')
          })
          .then(function () {
            self.archiving = false
          })
      },
      processArchive (id) {
        this.processArchives(id)
      },
      archiveSelected (){
        if(this.selected.length == 0){
          this.showMessage('No selected referrals', 'sb-default')
          return false;
        }

        this.processArchives(this.selected)
      },
      extendReferral (id){
        this.processExtendReferrals(id)
      },
      processExtendReferrals (ids){
        if(this.extending){
          return false;
        }

        this.extending = true
        let self = this

        this.$http.secured.post('api/referrals/extend/'+ ids)
          .then(response => {
            this.getReferral()
            this.getLatestReferralsSummary()
            this.showMessage(response.data.message, 'sb-success')
          })
          .catch(error => {
            if (error.response) {
              this.showMessage(error.response.data.messages.error, 'sb-failed')
            }else{
              this.showMessage("Something went wrong! Please try again.", 'sb-failed')
            }
          })
          .then(function () {
            self.extending = false
            self.selected = []
          })
      },
      editProject (idx){
        this.$router.push({ name:'teams_client_update', params: { id: this.client.slug }, query: { target: 'project-inq'+idx } })
      },
      filterByReferralStatus (filerStatus) {
        this.$router.push({ name: 'referral_status', params: { status: filerStatus } })
      },
      getLatestReferralsSummary () {
        this.$http.plain.get('api/referrals/summary')
          .then(response => {
            this.referralSummary = response.data
            this.loadedCnt++
          })
          .catch(error => {
            this.showMessage(error)
          })
      },
      getReferral () {
        this.$http.plain.get('api/referrals/'+ this.id)
          .then(response => {
            this.client = response.data
            this.team = response.data.team

            if(response.data.projectInquiries){
              this.projectInquiries = response.data.projectInquiries
            }

            if(this.projectInquiries.length > 0){
              this.projectInquiryDetails = this.projectInquiries[0]
            }

            if((this.client.company_name && this.client.company_name.length > 0)
              || (this.client.occupation && this.client.occupation.length > 0)
              || (this.client.home_ownership_id && this.client.home_ownership_id > 0)
              || (this.client.monthly_income_id && this.client.monthly_income_id > 0)){
              this.showPersonalInfo = true
            }

            if(response.data.homeAddress)
            {
                this.showHomeAddress = true
                this.homeAddress = response.data.homeAddress
            }

            this.loadedCnt++
          })
          .catch(error => {
            console.log(error);
          })
        }
    },
    mounted() {
      // M.AutoInit()
      this.domain = this.$store.getters.getApiURL
      this.id = this.$route.params.id
      this.getReferral()
      this.getLatestReferralsSummary()
      if(this.$route.query.updated){
        this.showMessage(this.$route.query.msg, 'sb-success')
        this.$router.push({ name: 'teams_client_view', params: { id: this.id } })
      }
      // this.projectInquiryDetails.push(this.projectInquiryDetails)
    },
    components: {
      ProjectInfoView,
      SnackBar,
      ConfirmationDialog,
      BodyLoader,
      ToTop,
      DataPrivacyConsent
    }
  }
</script>
